import { combineReducers } from "redux";
import tagRequestReducer from "./tagRequestReducer";
import reasonReducer from "./reasonReducer";
import uomReducer from "./uomReducer";

export default combineReducers({
    generateTag: tagRequestReducer,
    reasons: reasonReducer,
    uoms: uomReducer,
});
